import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import AutomationPostModalAdditionalDetails from 'components/AutomationPostModalAdditionalDetails';
import ShareFormTextarea from 'components/ShareForm/ShareFormTextarea';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import YoutubePlaylistSelector, {
  YoutubePlaylistSelectorProps,
} from 'containers/YoutubePostModal/YoutubePlaylistSelector';
import {
  youtubeIsPostingSelector,
  youtubePlaylistsSelector,
} from 'redux/modules/social';
import { makeSocialPostLengthCounter } from 'utils/string';
import { socialShareModalBlock as block } from '../../../../utils';
import {
  YOUTUBE_MAX_DESCRIPTION_CHARS,
  YOUTUBE_MAX_TITLE_CHARS,
} from './constants';

const zeroSocialPostLengthCounter = makeSocialPostLengthCounter(0);

export type YouTubeComposerStepProps = {
  title: string;
  selectedPlaylistsIds: YoutubePlaylistSelectorProps['value'];
  onTitleChange: (title: string) => void;
  onPlaylistChange: YoutubePlaylistSelectorProps['onChange'];
};

const YouTubeComposerStep: React.FC<YouTubeComposerStepProps> = ({
  title,
  selectedPlaylistsIds,
  onTitleChange,
  onPlaylistChange,
}) => {
  const { playlists } = useSelector(youtubePlaylistsSelector);
  const isPosting = useSelector(youtubeIsPostingSelector);

  const { description, setDescription, goToStep } = useSocialShareModal();

  return (
    <SocialShareModalBody loadingTitle="Posting Video" isLoading={isPosting}>
      <Spacer
        orientation="vertical"
        justify="center"
        align="start"
        space="20px"
        className={block('step-contents-container')}
      >
        <ShareFormTextarea
          label="Title"
          type="input"
          maxChars={YOUTUBE_MAX_TITLE_CHARS}
          value={title}
          onChange={onTitleChange}
        />

        <SocialShareModalAICaptionsField
          inputProps={{
            label: 'Description',
            value: description,
            maxChars: YOUTUBE_MAX_DESCRIPTION_CHARS,
            countRemaining: zeroSocialPostLengthCounter,
            onChange: setDescription,
          }}
        />

        <YoutubePlaylistSelector
          options={playlists}
          value={selectedPlaylistsIds}
          onCreatePlaylistClick={() => goToStep('create-playlist')}
          onChange={onPlaylistChange}
        />

        <AutomationPostModalAdditionalDetails
          onClick={() => goToStep('additional-details')}
        />
      </Spacer>
    </SocialShareModalBody>
  );
};

export default YouTubeComposerStep;
